import { useState, useEffect } from "react";
import api, { apiError } from "@/lib/api";
import { toast } from "sonner";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter } from "@/components/ui/dialog";

// product: null = fechado, {} = novo, {id,...} = edição
export const StockProductDialog = ({ product, onClose, onSaved }) => {
  const [f, setF] = useState({ name: "", unit: "un", min_quantity: "0" });
  const [busy, setBusy] = useState(false);
  const editing = !!product?.id;
  useEffect(() => {
    if (product) setF({ name: product.name || "", unit: product.unit || "un", min_quantity: String(product.min_quantity ?? 0) });
  }, [product]);

  const save = async () => {
    if (!f.name.trim()) { toast.error("Informe o nome do produto"); return; }
    if (!f.unit.trim()) { toast.error("Informe a unidade de medida"); return; }
    setBusy(true);
    try {
      const body = { name: f.name.trim(), unit: f.unit.trim(), min_quantity: Math.max(0, parseInt(f.min_quantity, 10) || 0) };
      if (editing) await api.put(`/admin/stock/products/${product.id}`, body);
      else await api.post("/admin/stock/products", body);
      toast.success(editing ? "Produto atualizado" : "Produto criado");
      onClose();
      onSaved();
    } catch (e) { toast.error(apiError(e)); } finally { setBusy(false); }
  };

  const cls = "border-slate-700 bg-slate-950 text-slate-100";
  return (
    <Dialog open={!!product} onOpenChange={(o) => !o && onClose()}>
      <DialogContent className="max-w-md border-slate-800 bg-slate-900" data-testid="stock-product-dialog">
        <DialogHeader><DialogTitle className="text-slate-100">{editing ? "Editar produto" : "Novo produto"}</DialogTitle></DialogHeader>
        <div className="space-y-4">
          <div className="space-y-2"><Label className="text-slate-300">Nome</Label>
            <Input value={f.name} maxLength={60} onChange={(e) => setF({ ...f, name: e.target.value })} data-testid="stock-product-name" className={cls} /></div>
          <div className="grid grid-cols-2 gap-3">
            <div className="space-y-2"><Label className="text-slate-300">Unidade de medida</Label>
              <Input value={f.unit} maxLength={20} placeholder="un, cx, kg..." onChange={(e) => setF({ ...f, unit: e.target.value })} data-testid="stock-product-unit" className={cls} /></div>
            <div className="space-y-2"><Label className="text-slate-300">Qtd. mínima (alerta)</Label>
              <Input type="number" min="0" value={f.min_quantity} onChange={(e) => setF({ ...f, min_quantity: e.target.value })} data-testid="stock-product-min" className={cls} /></div>
          </div>
        </div>
        <DialogFooter>
          <Button variant="ghost" className="text-slate-400" onClick={onClose} data-testid="stock-product-cancel">Cancelar</Button>
          <Button className="bg-orange-500 text-white hover:bg-orange-600" onClick={save} disabled={busy} data-testid="stock-product-save">{editing ? "Salvar" : "Criar produto"}</Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};
